import {
  REQUEST_SIDEBAR,
  RECEIVE_SIDEBAR,
  ERROR_SIDEBAR,
  TOGGLE_MENU_ITEM,
  RESIZE_REQUIRED,
  RESIZE_COMPLETE,
  SIDEBAR_EXPAND, SIDEBAR_CONTRACT,
  TOGGLE_ACTIVE_SIDEBAR_MODULE,
  UPDATE_HEADER,
  CLEAR_HEADER,
  APPEND_HEADER,
  CLEAR_HEADER_DEFINITIONS,
  TOGGLE_WINDOW,
  CLOSE_WINDOW,
  CORELAYOUT_HEADER_VISIBILITY_CHANGE,
  CORELAYOUT_SIDEBAR_VISIBILITY_CHANGE,
} from 'typeConstants';

import { combineReducers } from 'redux';
import {
  sidebar as initialSidebarState,
  display as initialDisplayState,
  coreLayoutSettings as initialCoreLayoutSettings,
  headerDefinitions,
  popoutWindows,
} from '../initialState.tsx';
import { map, cloneDeep } from 'lodash';

const toggleMenuItem = (items, menuId) =>
  map(items, (item) => {
    if (menuId === item.id) {
      item.isShow = !item.isShow;
    } else if (item.menuItems && item.menuItems.length) {
      item.menuItems = toggleMenuItem(item.menuItems, menuId);
    } else {
      item.menuItems = [];
    }
    return item;
  });

export const display = (state = initialDisplayState, action) => {
  switch (action.type) {
    case RESIZE_REQUIRED:
      return {
        ...state,
        resizeRequired: action.payload
      };
    case RESIZE_COMPLETE:
      return {
        ...state,
        resizeRequired: action.payload
      };
    default:
      return state;
  }
};

export const sidebar = (state = initialSidebarState, action) => {
  switch (action.type) {
    case REQUEST_SIDEBAR:
      return {
        ...state,
        isFetching: true
      };
    case RECEIVE_SIDEBAR:
      return {
        ...state,
        items: action.payload,
        isFetching: false
      };
    case ERROR_SIDEBAR:
      return {
        ...state,
        isFetching: false
      };
    case TOGGLE_MENU_ITEM:
      return {
        ...state,
        items: toggleMenuItem(cloneDeep(state.items), action.menuId)
      };
    case SIDEBAR_EXPAND:
      return {
        ...state,
        expanded: true,
      };
    case SIDEBAR_CONTRACT:
      return {
        ...state,
        expanded: false,
      };
    case TOGGLE_ACTIVE_SIDEBAR_MODULE:
      return {
        ...state,
        activeModule: action.payload,
      };
    default:
      return state;
  }
};

export const header = (state = headerDefinitions, action) => {
  switch (action.type) {
    case UPDATE_HEADER: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case CLEAR_HEADER:
      return { buttons: [], topMenuTitle: null, dropdownTitle: null };
    case APPEND_HEADER: {
      // get existing buttons that aren't in the inbound payload
      let existingButtons = state.buttons.filter((existing) => !action.payload.buttons.map((newButton) => newButton.name).includes(existing.name));
      return {
        ...state,
        buttons: [...existingButtons, ...action.payload.buttons]
      };
    }
    case CLEAR_HEADER_DEFINITIONS: {
      let clearButtons = action.payload.buttons?.map((x) => x.name) ?? [];
      return {
        ...state,
        buttons: [...state.buttons.filter((button) => !clearButtons.includes(button.name))]
      };
    }
    default:
      return state;
  }
};

export const popouts = (state = popoutWindows, action) => {
  switch (action.type) {
    case TOGGLE_WINDOW:
      return {
        ...state,
        active: (state.active.some(({ title }) => title === action.payload.title) ? (
          state.active.filter(({ title }) => title !== action.payload.title)
        ) : (
            [...state.active, action.payload]
          )),
      };
    case CLOSE_WINDOW:
      return {
        ...state,
        active: state.active.filter(({ title }) => title !== action.payload.title),
      };
    default:
      return state;
  }
};

export const coreLayoutSettings = (state = initialCoreLayoutSettings, action) => {
  switch(action.type) {
    case CORELAYOUT_HEADER_VISIBILITY_CHANGE:
      return {
        ...state,
        headerVisible: action.payload,
      };
    case CORELAYOUT_SIDEBAR_VISIBILITY_CHANGE:
      return {
        ...state,
        sidebarVisible: action.payload,
      };
    default:
      return state;
  }
};

const layout = combineReducers({
  sidebar,
  display,
  header,
  popouts,
  coreLayoutSettings,
});

export default layout;
